import { MoCommand } from './command';

/**
 * ActorObject command for handling stopping (play idle animation)
 *
 * @event enter When this command enters.
 * @event leave When this command leaves.
 * @event finish When we reach our target position.
 *
 * @param object
 * @constructor
 */
export class SitCmd extends MoCommand {
  ending: boolean;

  constructor(object: any) {
    super(object);
    this.ending = false;
  }

  enter() {
    this.object.pawn.playSitDownMotion(this._sitDownDone.bind(this));
  }

  _sitDownDone() {
    this.object.pawn.playSittingMotion();
  }

  beginLeave() {
    this.object.pawn.playStandUpMotion(this._standUpDone.bind(this));
  }

  _standUpDone() {
    this.isComplete = true;
    this.emit('finish');
  }

  leave() {
  }

  update(delta: number) {
    if (this.wantInterrupt && !this.ending) {
      this.ending = true;
      this.beginLeave();
    }
    return 0;
  }
}

